import GetDeviceStateData from "../api/GetDeviceState";
export default async function DetDeviceState(props) {
  var _res = await GetDeviceStateData({ ...props });
  if (_res.status === 200) {
    return _res.data;
  } else {
    return [];
  }
}
